import { Store } from "vuex";
import { AdobePageLoadEvent } from "./adobe-page-load";
import { AppState } from "@/store";
import { ServicesContainer } from "@/services";
import { CancelOrderConfirmationVisibleEvent } from "@/services/analytics/events";
import { WebPageDetails } from "../models";
import { GETTERS } from "@/store/customer";

export class AdobeCancelOrderConfirmationPageLoadEvent extends AdobePageLoadEvent {
  constructor(event: CancelOrderConfirmationVisibleEvent, store: Store<AppState>, services: ServicesContainer) {
    super(store, services);

    Object.assign(this.web.webPageDetails, {
      name: `order:cancel-order-confirmation`,
      language: window.navigator.language ? window.navigator.language.toLowerCase() : 'not-set',
      previousPage: document.referrer,
      pageViews: {
        value: 1,
      },
      siteRegion: store.state.ui.countryProfile.countryCode || '',
    } as WebPageDetails);

    Object.assign(this.account, {
      loginStatus: !!store.getters[GETTERS.IS_LOGGED_IN],
      userID: store.state.customer.profile?.customerIdHash,
      orderCancellation: {
        orderCancellationReason: event.cancellationReason,
        orderCancelled: {
          value: 1,
        }
      }
    })

  }
}